import { Box, styled } from '@mui/material';

export const InfoFieldContainerStyled = styled(Box)(() => ({
  width: '100%',
}));

export const FieldValueStyled = styled(Box)(({ theme }) => ({
  borderRadius: 4,
  backgroundColor: theme.palette.colors.infoBackground,
  fontSize: 12,
  width: '100%',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  fontWeight: 500,
  padding: '8px',
}));
